import { ReactNode } from "react";
import styled from '@emotion/styled';
import { boldTypes, colors } from "src/theme";
import { MergeWithOverwrite } from "src/common";

type FontSize = "large" | "medium" | "small" | "tiny";

const typographyConfig = {
  large: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '1.92px',
    fontWeight: '400',
  },
  medium: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '1.68px',
    fontWeight: '400',
  },
  small: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '1.2px',
    fontWeight: '600',
  },
  tiny: {
    fontSize: '10px',
    lineHeight: '12px',
    letterSpacing: '1.2px',
    fontWeight: '400',
  },
};

const LabelStyle = styled.div((props: { type: FontSize, color: string, bold: boolean }) => ({
  ...typographyConfig[props.type],
  color: props.color,
  fontWeight: props.bold ? boldTypes.bold : boldTypes.normal,
}));

export type LabelProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLDivElement>, {
  type: FontSize;
  color?: string;
  bold?: boolean;
  children: ReactNode;
  className?: string;
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
}>;

export const Label = ({ type, color = colors.text1, bold = false, children, className, textTransform = 'none' }: LabelProps) => (
  <LabelStyle type={type} color={color} bold={bold} className={className} style={{ textTransform }}>
    {children}
  </LabelStyle>
);
